(() => {
  const initialize = (root) => {
    if (root.dataset.accessoryReady) return;
    root.dataset.accessoryReady = 'true';
    const total = root.querySelector('[data-accessory-total]');
    const value = root.querySelector('[data-accessory-total-value]');
    const quantity = root.querySelector('.quantity__input');
    const form = root.querySelector('product-form form');
    const color = root.querySelector('[data-accessory-color]');
    let price = Number(total.dataset.price);
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:total.dataset.currency || 'USD'});
    const update = () => {
      const count = Number(quantity.value);
      value.textContent = price === null ? total.dataset.unavailable : format.format(price * (Number.isFinite(count) && count > 0 ? count : 0) / 100);
    };
    color?.addEventListener('input', () => color.setCustomValidity(''));
    form.addEventListener('submit', (event) => {
      if (color && !color.value.trim()) color.setCustomValidity(color.dataset.requiredMessage);
      if (!form.reportValidity() || price === null || price <= 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    quantity.addEventListener('input', update);
    quantity.addEventListener('change', update);
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.quantityUpdate, update);
      subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (data.sectionId !== root.dataset.section) return;
        price = data.variant ? data.variant.price : null;
        const purpose = root.querySelector('[data-accessory-purpose]');
        const source = data.html?.querySelector('[data-accessory-purpose]');
        if (purpose && source) purpose.innerHTML = source.innerHTML;
        update();
      });
    }
    update();
  };
  document.querySelectorAll('product-info.cfd-accessory-page').forEach(initialize);
  document.addEventListener('product-info:loaded', (event) => {
    if (event.target.matches('.cfd-accessory-page')) initialize(event.target);
  });
})();
